import type { Router } from 'vue-router';
import { PageEnum } from '@mts/enums/pageEnum';
import { removeTabChangeListener } from '@mts/logics/mitt/routeChange';
import { registeGlobalParam } from '@mts/utils';
import { IN_DEV } from '@mts/utils/env';
import {
  getAppStore,
  getGlobalStore,
  getMultipleTabStore,
  getPermissionStore,
  getUserStore,
} from '@/store';

const LOGIN_PATH = PageEnum.BASE_LOGIN;
export function createStateGuard(router: Router) {
  const tabStore = getMultipleTabStore();
  const userStore = getUserStore();
  const appStore = getAppStore();
  const globalStore = getGlobalStore();
  const permissionStore = getPermissionStore();

  router.beforeEach(() => {
    globalStore.resetRouteCache();
    return true;
  });

  router.afterEach((to, from) => {
    if (to.path === LOGIN_PATH) {
      appStore.resetAllState();
      permissionStore.resetState();
      tabStore.resetState();
      userStore.resetState();
      removeTabChangeListener();
    }

    if (from.meta?.parentPath === to.path) {
      getMultipleTabStore().closeOtherTabs(to, router);
    }

    registeGlobalParam({ route: to });

    IN_DEV && globalStore.cacheRoutePage(to);
    // from.path === LOGIN_PATH && openTenantModal();
  });
}
